var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.921509,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#004087"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2813 21.2034H18.0587V17.7216C18.0587 16.8914 18.0437 15.8224 16.9025 15.8224C15.7448 15.8224 15.5676 16.7268 15.5676 17.6606V21.2031H13.345V14.0449H15.4787V15.0233H15.5074C15.721 14.6582 16.0296 14.3578 16.4004 14.1542C16.7712 13.9506 17.1902 13.8514 17.6129 13.8671C19.8658 13.8671 20.2813 15.349 20.2813 17.2767V21.2034ZM10.8369 13.0663C10.5817 13.0663 10.3323 12.9907 10.1201 12.849C9.90795 12.7073 9.74256 12.5058 9.64488 12.2701C9.5472 12.0344 9.52161 11.775 9.57135 11.5248C9.62109 11.2745 9.74393 11.0446 9.92433 10.8642C10.1047 10.6838 10.3346 10.5609 10.5848 10.5111C10.8351 10.4613 11.0945 10.4868 11.3302 10.5844C11.5659 10.6821 11.7674 10.8474 11.9092 11.0595C12.0509 11.2717 12.1266 11.5211 12.1266 11.7763C12.1266 12.1183 11.9907 12.4464 11.7489 12.6883C11.507 12.9302 11.179 13.0662 10.8369 13.0663ZM11.9482 21.2031H9.72328V14.0449H11.9485L11.9482 21.2031ZM21.3883 8.42248H8.60622C8.46243 8.42074 8.3197 8.44737 8.18622 8.50085C8.05273 8.55434 7.93111 8.63363 7.82831 8.73418C7.72551 8.83474 7.64356 8.95458 7.58714 9.08685C7.53072 9.21912 7.50094 9.36122 7.49951 9.50502V22.3389C7.50293 22.6292 7.62143 22.9062 7.829 23.1092C8.03656 23.3122 8.31621 23.4245 8.6065 23.4214H21.3883C21.6793 23.4253 21.96 23.3135 22.1687 23.1105C22.3773 22.9075 22.4967 22.6299 22.5007 22.3389V9.50272C22.4966 9.21183 22.377 8.93452 22.1684 8.73178C21.9598 8.52904 21.6792 8.41747 21.3883 8.42162",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f45af2d68f2de149d062eddc3cf22ed5.svg";
export { ForwardRef as ReactComponent };